// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-flag-docs',
    templateUrl: './flag.docs.generated.html',
})
export class UIFlagDocs { }
